import axios from "axios";

export default {
  state: () => ({}),

  mutations: {},

  actions: {
    // Staff
    loadActiveLostPropertyCategories: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/staff/lost-property/categories").then((response) => {
        return response.data;
      });
    },

    registerLostPropertyFoundItem: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/staff/lost-property/found-items", request).then((response) => {
        return response.data;
      });
    },

    loadLostPropertyFoundItem: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/staff/lost-property/found-items/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadLostPropertyFoundItemByBarcode: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/staff/lost-property/found-items/barcode/" + request.barcode, {
          params: { environment: "dev" },
        })
        .then((response) => {
          return response.data;
        });
    },

    uploadLostPropertyFoundItemPhoto: (context, { id, uploadBean }) => {
      return axios.post(context.getters.getMcServiceUrl + "/staff/lost-property/found-items/" + id + "/photos", uploadBean).then((response) => {
        return response.data;
      });
    },

    loadLostPropertyFoundItemPhotos: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/staff/lost-property/found-items/" + request.id + "/photos").then((response) => {
        return response.data;
      });
    },

    // Admin
    loadLostPropertyPendingReports: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/admin/lost-property/reports/pending").then((response) => {
        return response.data;
      });
    },

    loadLostPropertyMatchCandidates: (context, { reportId, toleranceDays }) => {
      const params = { environment: "dev" };
      if (toleranceDays) {
        params.toleranceDays = toleranceDays;
      }
      return axios
        .get(context.getters.getMcServiceUrl + "/admin/lost-property/reports/" + reportId + "/candidates", { params })
        .then((response) => {
          return response.data;
        });
    },

    loadLostPropertyReportBooking: (context, reportId) => {
      return axios.get(context.getters.getMcServiceUrl + "/admin/lost-property/reports/" + reportId + "/booking").then((response) => {
        return response.data;
      });
    },

    createLostPropertyMatch: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/admin/lost-property/matches", request).then((response) => {
        return response.data;
      });
    },

    rollbackLostPropertyMatch: (context, { id, request }) => {
      return axios.post(context.getters.getMcServiceUrl + "/admin/lost-property/matches/" + id + "/rollback", request || {}).then((response) => {
        return response.data;
      });
    },

    deliverLostPropertyMatched: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/admin/lost-property/deliveries", request).then((response) => {
        return response.data;
      });
    },

    deliverLostPropertyWalkin: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/admin/lost-property/deliveries/walkin", request).then((response) => {
        return response.data;
      });
    },

    loadLostPropertyInventory: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/admin/lost-property/found-items", {
          params: { environment: "dev" },
        })
        .then((response) => {
          return response.data;
        });
    },

    loadLostPropertyPhotosByItems: (context, { ids }) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/admin/lost-property/found-items/photos", {
          params: { foundItemIds: (ids || []).join(",") },
        })
        .then((response) => {
          return response.data;
        });
    },

    loadLostPropertyReportItemsByReports: (context, { ids }) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/admin/lost-property/reports/items", {
          params: { reportIds: (ids || []).join(",") },
        })
        .then((response) => {
          return response.data;
        });
    },

    loadExpiredLostPropertyFoundItems: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/admin/lost-property/found-items/expired", {
          params: { environment: "dev" },
        })
        .then((response) => {
          return response.data;
        });
    },

    loadDeliverableLostProperty: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/admin/lost-property/deliverable", {
          params: { ...(request || {}), environment: "dev" },
        })
        .then((response) => {
          return response.data;
        });
    },

    disposeLostPropertyFoundItem: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/admin/lost-property/disposals", request).then((response) => {
        return response.data;
      });
    },

    loadLostPropertyConfig: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/admin/lost-property/config").then((response) => {
        return response.data;
      });
    },

    updateLostPropertyConfig: (context, request) => {
      return axios.put(context.getters.getMcServiceUrl + "/admin/lost-property/config", request).then((response) => {
        return response.data;
      });
    },

    loadAllLostPropertyCategories: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/admin/lost-property/categories").then((response) => {
        return response.data;
      });
    },

    createLostPropertyCategory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/admin/lost-property/categories", request).then((response) => {
        return response.data;
      });
    },

    updateLostPropertyCategory: (context, { id, request }) => {
      return axios.put(context.getters.getMcServiceUrl + "/admin/lost-property/categories/" + id, request).then((response) => {
        return response.data;
      });
    },
  },

  getters: {},
};
